export enum AssetTypeEnum {
    
    MOVABLE = 'MOVABLE',
    FIXED = 'FIXED',
    SOFTASSET = 'SOFTASSET',
}